import { Image, Select, Space, Typography } from "antd";
import { Header } from "antd/es/layout/layout";
import Flag from "react-world-flags";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import LogoIcon from "../../assets/sprites/logo_og_books.png";
import { Language, WebRoutes } from "../../handlers/enums";
import { UserId } from "../../handlers/globals";

export default function ComponentHeader() {
  const { i18n } = useTranslation();
  const [userId] = useAtom(UserId);

  return (
    <Header className="mx-auto mb-3 h-auto w-full max-w-xl rounded-2xl border border-white/10 bg-custom-grey/60 px-3 py-2 backdrop-blur-md">
      {!userId ? (
        <div className="relative flex items-center justify-center">
          <Link className="flex items-center gap-2 focus-visible:outline-none" to={WebRoutes.Home}>
            <Image height={42} width={42} className="min-w-[42px] rounded-xl" src={LogoIcon} preview={false} />
            <Typography.Title level={5} className="!m-0 !text-custom-white">Vvoids Books</Typography.Title>
          </Link>
          <Select
            value={i18n.language}
            onChange={(value) => i18n.changeLanguage(value)}
            className="app-select absolute right-0 top-1/2 w-[112px] -translate-y-1/2"
            popupMatchSelectWidth={false}
            popupClassName="app-select-dropdown"
            options={[
              { value: Language.English, label: <Space size={6}><Flag width={20} code={Language.EnglishAlt} />EN</Space> },
              { value: Language.Dutch, label: <Space size={6}><Flag width={20} code={Language.Dutch} />NL</Space> }
            ]}
          />
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <Link className="flex items-center gap-2 focus-visible:outline-none" to={WebRoutes.Home}>
            <Image height={42} width={42} className="min-w-[42px] rounded-xl" src={LogoIcon} preview={false} />
          </Link>
          <Select
            value={i18n.language}
            onChange={(value) => i18n.changeLanguage(value)}
            className="app-select w-[112px]"
            popupMatchSelectWidth={false}
            popupClassName="app-select-dropdown"
            options={[
              { value: Language.English, label: <Space size={6}><Flag width={20} code={Language.EnglishAlt} />EN</Space> },
              { value: Language.Dutch, label: <Space size={6}><Flag width={20} code={Language.Dutch} />NL</Space> }
            ]}
          />
        </div>
      )}
    </Header>
  );
}
